module.exports = __webpack_public_path__ + "static/media/home.4ee65dec.svg";